import useMediaQuery from "./useMediaQuery"

export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
} as const

const useBreakpoint = (breakpoint: keyof typeof breakpoints) => {
  const matches = useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`)
  return matches
}

export default useBreakpoint
